// extracted by mini-css-extract-plugin
module.exports = {"wizard":"Setup_wizard__3NaXv"};